export default {
  accordionItem: {
    base: {
      borderBottom: '1px solid',
      borderColor: 'grey-60',
      bg: 'grey-05',
      variant: 'spark.base.wrapper'
    }
  },
  accordionButton: {
    base: {
      hover: {
        bg: 'grey-20',
        textDecoration: 'underline'
      },
      focus: {
        bg: 'cyan',
        outline: 'none'
      }
    }
  },
  accordionPanel: {}
};